import { Button, Form, Row, Col } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";

import FormContainer from "../components/FormContainer";
import Loader from "../components/Loader";
import { useUpdateAttendanceMutation } from "../slices/attendanceSlice";
import welcomeMessage from "../assets/audios/messageTone.mp3";
import errorTone from "../assets/audios/error_tone.mp3";
import { setCredentials } from "../slices/authSlice";
import ProfileImage from "../components/ProfileImage";
import birthdayTone from "../assets/audios/happyBirthday.mp3";
import { getCurrentDate } from "../utils/getCurrentDate";
import { useNavigate } from "react-router-dom";
import { useLogoutMutation } from "../slices/gymSlice";
import { logout } from "../slices/authSlice";
import { useGetMyGymQuery } from "../slices/gymSlice";
import MemberImage from "../components/ImageManager";
import { useUpdateAssociateAttendanceMutation } from "../slices/associatesSlice";

const AttendanceScreenForUsers = () => {
  const [userId, setUserId] = useState();
  const { userInfo } = useSelector((state) => state.auth);

  const [imageError, setImageError] = useState(false);
  const [userExist, setUserExist] = useState(false);
  const [userDetails, setUserDetails] = useState();
  const [adminAttendanceEnabled, setAdminAttendanceEnabled] = useState(false);
  const [associateId, setAssociateId] = useState("");

  const [updateAttendance, { isLoading }] = useUpdateAttendanceMutation();
  const topRef = useRef(null);

  const [isToggled, setIsToggled] = useState(userInfo.audioOn);
  let {
    data: myGymDetails,
    isLoading: gymDetailsLoading,
    error,
    refetch,
  } = useGetMyGymQuery({
    token: userInfo.token,
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleToggle = () => {
    setIsToggled(!isToggled);
    dispatch(setCredentials({ ...userInfo, audioOn: !isToggled }));
  };

  const [logoutApi] = useLogoutMutation();
  let gymId;
  if (userInfo) {
    gymId = userInfo?.gymId?._id;
  }

  const [updateAssociateAttendance, { isUpdateAttendanceLoading }] =
    useUpdateAssociateAttendanceMutation();

  const handleLogout = async () => {
    try {
      await logoutApi().unwrap();
      dispatch(logout());
      navigate("/login");
      toast.success("Successfully logged out");
    } catch (err) {
      console.log(err);
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (!userInfo) toast.error("Please login to use the application");
    if (
      userId?.toString().toLowerCase().length < 1 ||
      userId?.toString().toLowerCase().length > 99 ||
      !userId
    ) {
      toast.error("Please enter valid Member Id");
      setUserId("");
    } else {
      try {
        const res = await updateAttendance({
          payLoad: {
            userId: userId?.toString().toLowerCase(),
          },
          token: userInfo.token,
        }).unwrap();

        setUserExist(true);
        setUserDetails(res);
        if (window.innerWidth < 1200)
          if (res.subsAlreadyExpired) {
            toast.error(
              () => (
                <div
                  style={{
                    padding: "3px",
                    fontSize: "1.2em",
                    lineHeight: "1.5",
                    backgroundColor: "red",
                  }}
                >
                  <audio
                    src={errorTone}
                    type="audio/mp3"
                    autoPlay={isToggled}
                  ></audio>

                  <br></br>

                  <label style={{ color: "white" }}>
                    {res?.userName}
                    <br></br>
                    {res?.userId}
                    <br></br>
                    Subscription EXPIRED on : {res?.expiresOn?.split("T")[0]}
                  </label>
                  {res?.pendingAmount > 0 && (
                    <label>Pending Amount : {res?.pendingAmount}</label>
                  )}
                  <br></br>
                </div>
              ),
              {
                style: { width: userInfo?.isMobileScreen ? "350px" : "500px" },
              }
            );
          } else {
            res?.dateOfBirth?.toString().split("T")[0] !== "2021-01-01" &&
            res?.dateOfBirth?.toString().split("T")[0].substring(4) ===
              getCurrentDate().substring(4)
              ? toast.success(
                  () => (
                    <div
                      style={{
                        padding: "20px",
                        fontSize: "1.2em",
                        lineHeight: "1.5",
                        textAlign: "center", // Center align the content
                        position: "relative", // Required for overlay graphics
                        background: "linear-gradient(135deg, #00d2ff, #3a7bd5)", // Gradient background
                        borderRadius: "15px",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                        overflow: "hidden",
                      }}
                    >
                      {/* Play Birthday Tone */}
                      <audio
                        src={birthdayTone}
                        type="audio/mp3"
                        autoPlay={isToggled}
                      ></audio>
                      {/* Display Profile Image */}
                      <MemberImage
                        memberId={userInfo?.gymId?._id + "" + res.userId}
                        imageUpdatedTimeFromDB={res.imageUploadedTime}
                        expiryDate={res.expiresOn}
                        photoUploaded={res.photoUploaded}
                        width="18rem"
                        height="18rem"
                      />
                      {/* Birthday Message */}
                      <br />
                      <strong style={{ fontSize: "1.5em", color: "#fff" }}>
                        🎉 {res?.message} {res?.userName}! 🎂
                      </strong>
                      <br />
                      <strong style={{ fontSize: "1.5em", color: "green" }}>
                        Happy Birthday
                      </strong>
                      <br />
                      <strong>
                        <p style={{ color: "green" }}>
                          {res?.message?.includes("Bye") &&
                            "Workout Minutes : " +
                              (
                                (Number(res?.timeOut) - Number(res?.timeIn)) /
                                60000
                              ).toFixed(0)}
                        </p>
                      </strong>
                      <p style={{ color: "#fff", fontSize: "1em" }}>
                        Valid Till: {res?.expiresOn?.split("T")[0]}
                        <br />
                        Expires in:{" "}
                        {Math.ceil(
                          (new Date(res?.expiresOn) - new Date()) /
                            (1000 * 60 * 60 * 24)
                        ) === 0
                          ? "Expiring Today"
                          : Math.ceil(
                              (new Date(res?.expiresOn) - new Date()) /
                                (1000 * 60 * 60 * 24)
                            ) + " days"}
                      </p>{" "}
                      {res?.pendingAmount > 0 && (
                        <label style={{ color: "red" }}>
                          Pending Amount : {res?.pendingAmount}
                        </label>
                      )}
                    </div>
                  ),
                  {
                    style: {
                      width: userInfo?.isMobileScreen ? "350px" : "500px",
                    },
                  }
                )
              : toast.success(
                  () => (
                    <div
                      style={{
                        padding: "20px",
                        fontSize: "1.2em",
                        lineHeight: "1.5",
                        textAlign: "center", // Center align the content
                        position: "relative", // Required for overlay graphics
                        background:
                          !res.message?.toLowerCase().includes("bye") &&
                          (new Date().getHours() <
                            Number(res.attOutsideAllowedRange?.split("_")[0]) ||
                            new Date().getHours() >=
                              Number(res.attOutsideAllowedRange?.split("_")[2]))
                            ? "#ff9a9e"
                            : "", // Gradient background
                        borderRadius: "15px",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                        overflow: "hidden",
                      }}
                    >
                      {!res.message?.toLowerCase().includes("bye") &&
                        (new Date().getHours() <
                          Number(res.attOutsideAllowedRange?.split("_")[0]) ||
                          (new Date().getHours() >
                            Number(
                              res.attOutsideAllowedRange?.split("_")[2]
                            ) && (
                            <h6>You are coming out of your allowed time</h6>
                          )))}
                      {/* Play Birthday Tone */}
                      <audio
                        src={welcomeMessage}
                        type="audio/mp3"
                        autoPlay={isToggled}
                      ></audio>
                      {/* Display Profile Image */}
                      {window.innerWidth > 600 && (
                        <MemberImage
                          memberId={userInfo?.gymId?._id + "" + res.userId}
                          imageUpdatedTimeFromDB={res.imageUploadedTime}
                          expiryDate={res.expiresOn}
                          photoUploaded={res.photoUploaded}
                          width="18rem"
                          height="18rem"
                        />
                      )}
                      <br />
                      <strong style={{ fontSize: "1.5em" }}>
                        {res?.message} {res?.userName}
                      </strong>
                      <strong>
                        <p style={{ color: "green" }}>
                          {res?.message?.includes("Bye") &&
                            "Workout Minutes : " +
                              (
                                (Number(res?.timeOut) - Number(res?.timeIn)) /
                                60000
                              ).toFixed(0)}
                        </p>
                      </strong>
                      <p style={{ fontSize: "1em" }}>
                        Valid Till : {res?.expiresOn?.split("T")[0]}
                        <br />
                        Expires in{" "}
                        {Math.ceil(
                          (new Date(res?.expiresOn) - new Date()) /
                            (1000 * 60 * 60 * 24)
                        ) === 0
                          ? "Expiring Today"
                          : Math.ceil(
                              (new Date(res?.expiresOn) - new Date()) /
                                (1000 * 60 * 60 * 24)
                            ) + " days"}
                      </p>{" "}
                      {res?.pendingAmount > 0 && (
                        <label style={{ color: "red" }}>
                          Pending Amount : {res?.pendingAmount}
                        </label>
                      )}
                    </div>
                  ),
                  {
                    style: {
                      width: userInfo?.isMobileScreen ? "350px" : "500px",
                    },
                  }
                );
          }

        setUserId("");
        const birthdayAudio = new Audio(birthdayTone);
        const welcomeAudio = new Audio(welcomeMessage);
        const errorSound = new Audio(errorTone);
        if (isToggled) {
          res?.dateOfBirth?.toString().split("T")[0] !== "2021-01-01" &&
          res?.dateOfBirth?.toString().split("T")[0].substring(4) ===
            getCurrentDate().substring(4)
            ? birthdayAudio.play()
            : res?.subsAlreadyExpired
            ? errorSound.play()
            : welcomeAudio.play();
        }
      } catch (err) {
        err.status === "PARSING_ERROR" || err.status === 400
          ? toast.error(() => (
              <div>
                <audio
                  src={errorTone}
                  type="audio/mp3"
                  autoPlay={isToggled}
                ></audio>
                <br />
                Please enter valid Member ID
              </div>
            ))
          : toast.error(err.error);
        setUserId("");
      }
    }
  };

  const submitAssociateHandler = async (e) => {
    e.preventDefault();
    if (!userInfo) {
      toast.error("Please login to use the application");
      return;
    }

    if (
      associateId?.toString().length < 2 ||
      associateId?.toString().length > 4 ||
      !associateId
    ) {
      toast.error("Please enter valid Member Id");
      return;
    }

    try {
      const res = await updateAssociateAttendance({
        payload: {
          associateId: associateId,
        },
        token: userInfo.token,
      }).unwrap();

      toast.success(() => (
        <div>
          <audio src={welcomeMessage} type="audio/mp3" autoPlay />
          <br />
          {res?.message}
          <br />
          <strong>
            Thank You {res?.data?.compositeId?.toString().substring(4)}
          </strong>
        </div>
      ));
      setAdminAttendanceEnabled((prev) => !prev);
      setAssociateId("");
      topRef.current?.scrollIntoView({ behavior: "smooth" });
    } catch (err) {
      err.status === "PARSING_ERROR" || err.status === 400
        ? toast.error(() => (
            <div>
              <audio src={errorTone} type="audio/mp3" autoPlay />
              <br />
              Please enter valid Employee ID
            </div>
          ))
        : toast.error(err.error);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setUserExist(false);
    }, 15000); // 10 seconds

    // Cleanup function to clear the timer if `userDetails` changes again
    return () => clearTimeout(timer);
  }, [userDetails]);

  const handleAdminToggle = () => {
    setAdminAttendanceEnabled((prev) => !prev);
  };

  // const imageId = 940310014;
  // const cacheBuster = new Date().getTime();

  return (
    <>
      <div ref={topRef}>
        <Row
          style={{
            alignItems: "center",
            height: "80vh",
            marginTop: "5px",
          }}
        >
          <Col md={6}>
            <ProfileImage
              imageId={userInfo.gymId?._id}
              setImageError={setImageError}
            />
            <FormContainer>
              <Form onSubmit={submitHandler}>
                <Form.Group
                  className="my-1"
                  controlId="userId"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center", // Center-aligns the input within the group
                  }}
                >
                  <Form.Label id="userId"></Form.Label>
                  <Form.Control
                    style={{
                      width: "400px", // Adjust to make it as long as you need
                      height: "50px",
                      margin: "10px",
                      padding: "20px",
                      fontSize: "30px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    type="text"
                    placeholder="type Member Id"
                    autoComplete="off"
                    autoFocus
                    value={userId || ""}
                    onChange={(e) => {
                      // Update userId only if input is alphanumeric (no special characters)
                      const newValue = e.target.value.replace(
                        /[^a-zA-Z0-9]/g,
                        ""
                      ); // Allow only letters and numbers
                      setUserId(newValue);
                    }}
                  />
                </Form.Group>
                <br />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    className={`${userInfo.themeColor}ThemeHeaderTop`}
                    type="submit"
                    variant="primary"
                  >
                    Submit
                  </Button>
                </div>
                {isLoading && <Loader />}
              </Form>
            </FormContainer>
          </Col>
          <Col md={6}>
            <Col sm="12">
              {userExist ? (
                <>
                  {userDetails?.dateOfBirth?.toString().split("T")[0] !==
                    "2021-01-01" &&
                  userDetails?.dateOfBirth
                    ?.toString()
                    .split("T")[0]
                    .substring(4) === getCurrentDate().substring(4) ? (
                    <div
                      style={{
                        width: "550px",
                        padding: "20px",
                        fontSize: "1.5em",
                        lineHeight: "1.5",
                        textAlign: "center", // Center align the content
                        position: "relative", // Required for overlay graphics
                        background: "linear-gradient(135deg, #00d2ff, #3a7bd5)", // Gradient background
                        borderRadius: "15px",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                        overflow: "hidden",
                        color: "white",
                      }}
                    >
                      {/* <audio
                      src={birthdayTone}
                      type="audio/mp3"
                      autoPlay={isToggled}
                    ></audio> */}
                      {window.innerWidth > 600 && (
                        <MemberImage
                          memberId={
                            userInfo?.gymId?._id + "" + userDetails.userId
                          }
                          imageUpdatedTimeFromDB={userDetails.imageUploadedTime}
                          expiryDate={userDetails.expiresOn}
                          photoUploaded={userDetails.photoUploaded}
                          width="18rem"
                          height="18rem"
                        />
                      )}
                      <br />
                      <strong style={{ fontSize: "1.5em", color: "#fff" }}>
                        {userDetails?.message} {userDetails?.userName}
                      </strong>
                      <br />
                      🎉{" "}
                      <strong style={{ fontSize: "1.5em", color: "green" }}>
                        Happy Birthday
                      </strong>{" "}
                      🎂
                      <br />
                      <strong>
                        <p style={{ color: "orange" }}>
                          {userDetails?.message?.includes("Bye") &&
                            "Workout Time : " +
                              Math.floor(
                                (Number(userDetails?.timeOut) -
                                  Number(userDetails?.timeIn)) /
                                  3600000
                              ) +
                              " Hour " +
                              Math.floor(
                                ((Number(userDetails?.timeOut) -
                                  Number(userDetails?.timeIn)) %
                                  3600000) /
                                  60000
                              ) +
                              " Minutes"}
                        </p>
                      </strong>
                      {userDetails?.pendingAmount > 0 && (
                        <label style={{ color: "red" }}>
                          Pending Amount : {userDetails?.pendingAmount}
                        </label>
                      )}
                      {userDetails.subsAlreadyExpired ? (
                        <label style={{ color: "white" }}>
                          Subscription EXPIRED on{" "}
                          {userDetails?.expiresOn?.split("T")[0]}
                        </label>
                      ) : (
                        <p style={{ color: "#fff", fontSize: "1em" }}>
                          Valid Till: {userDetails?.expiresOn?.split("T")[0]}
                          <br />
                          Expires in{" "}
                          {Math.ceil(
                            (new Date(userDetails?.expiresOn) - new Date()) /
                              (1000 * 60 * 60 * 24)
                          ) === 0
                            ? "Expiring Today"
                            : Math.ceil(
                                (new Date(userDetails?.expiresOn) -
                                  new Date()) /
                                  (1000 * 60 * 60 * 24)
                              ) + " days"}
                        </p>
                      )}
                    </div>
                  ) : (
                    <div
                      style={{
                        width: "550px",
                        padding: "20px",
                        fontSize: "2em",
                        lineHeight: "1.5",
                        textAlign: "center", // Center align the content
                        position: "relative", // Required for overlay graphics
                        // background: "linear-gradient(135deg, #ff9a9e, #fad0c4)", // Gradient background
                        backgroundColor: userDetails.subsAlreadyExpired
                          ? "red"
                          : "transparent",
                        borderRadius: "15px",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                        overflow: "hidden",
                        color: "white",
                      }}
                    >
                      {/* <audio
                      src={welcomeMessage}
                      type="audio/mp3"
                      autoPlay={isToggled}
                    ></audio> */}

                      {window.innerWidth > 600 && (
                        <MemberImage
                          memberId={
                            userInfo?.gymId?._id + "" + userDetails.userId
                          }
                          imageUpdatedTimeFromDB={userDetails.imageUploadedTime}
                          expiryDate={userDetails.expiresOn}
                          photoUploaded={userDetails.photoUploaded}
                          width="18rem"
                          height="18rem"
                        />
                      )}

                      <strong style={{ fontSize: "1.5em" }}>
                        {userDetails?.message} {userDetails?.userName}
                      </strong>

                      <strong>
                        <p style={{ color: "orange" }}>
                          {userDetails?.message?.includes("Bye") &&
                            "Workout Time : " +
                              Math.floor(
                                (Number(userDetails?.timeOut) -
                                  Number(userDetails?.timeIn)) /
                                  3600000
                              ) +
                              " Hour " +
                              Math.floor(
                                ((Number(userDetails?.timeOut) -
                                  Number(userDetails?.timeIn)) %
                                  3600000) /
                                  60000
                              ) +
                              " Minutes"}
                        </p>
                      </strong>

                      {userDetails?.pendingAmount > 0 && (
                        <label style={{ color: "orange" }}>
                          Pending Amount : {userDetails?.pendingAmount}
                        </label>
                      )}

                      {userDetails.subsAlreadyExpired ? (
                        <label style={{ color: "white" }}>
                          Subscription EXPIRED on{" "}
                          {userDetails?.expiresOn?.split("T")[0]}
                        </label>
                      ) : (
                        <p style={{ fontSize: "1em" }}>
                          Valid Till : {userDetails?.expiresOn?.split("T")[0]}
                          <br />
                          Expires in{" "}
                          {Math.ceil(
                            (new Date(userDetails?.expiresOn) - new Date()) /
                              (1000 * 60 * 60 * 24)
                          ) === 0
                            ? "Expiring Today"
                            : Math.ceil(
                                (new Date(userDetails?.expiresOn) -
                                  new Date()) /
                                  (1000 * 60 * 60 * 24)
                              ) + " days"}
                        </p>
                      )}
                    </div>
                  )}{" "}
                </>
              ) : (
                <>
                  {" "}
                  <Form.Label
                    disabled
                    style={{
                      fontSize: "40px",
                      backgroundColor: "transparent",
                      color: "cyan",
                      alignContent: "center",
                      border: "none",
                      whiteSpace: "pre-wrap",
                      marginLeft: "10px",
                    }}
                  >
                    {myGymDetails?.offerOne}
                  </Form.Label>
                </>
              )}
            </Col>
          </Col>
        </Row>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "99vh",
            marginTop: "30px",
          }}
        >
          <div style={{ marginTop: "20px" }}>
            <button
              style={{
                borderRadius: "8px",
                marginTop: "20px",
              }}
              onClick={handleToggle}
            >
              Sound : <b>{isToggled ? "ON" : "OFF"}</b>
            </button>
          </div>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />

          <div style={{ marginTop: "20px" }}>
            <button
              style={{
                borderRadius: "8px",
                marginTop: "20px",
              }}
              onClick={handleAdminToggle}
            >
              Admin Attendance
            </button>
          </div>
          {adminAttendanceEnabled && (
            <Form onSubmit={submitAssociateHandler}>
              <Form.Group
                className="my-1"
                controlId="associateId"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Form.Label id="associateId"></Form.Label>
                <Form.Control
                  style={{
                    width: "20rem",
                    height: "3rem",
                    margin: "0.6rem",
                    padding: "1rem",
                    fontSize: "2rem",
                  }}
                  type="text"
                  placeholder="type Associate Id"
                  autoComplete="off"
                  autoFocus
                  value={associateId || ""}
                  onChange={(e) => {
                    const newValue = e.target.value.replace(
                      /[^a-zA-Z0-9]/g,
                      ""
                    );
                    setAssociateId(newValue);
                  }}
                />
              </Form.Group>

              <br />
              <Row
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Button
                  className={`${userInfo.themeColor}ThemeHeaderTop marginPointOne sixteenWidth numbersButton`}
                  type="submit"
                  variant="primary"
                >
                  Submit
                </Button>
              </Row>
            </Form>
          )}

          <div>
            <button
              style={{ borderRadius: "8px", marginTop: "160px" }}
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AttendanceScreenForUsers;
